import type { FC } from "react";
import { Icon } from "../UI/Icon";

interface CloseIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export const CloseIcon: FC<CloseIconProps> = (props) => (
  <Icon {...props} variant="filled">
    <path d="M20.67 21.49C20.45 21.49 20.24 21.4 20.08 21.25L10.83 12.01C10.83 12.01 10.78 11.97 10.75 11.97C10.72 11.97 10.69 11.98 10.67 12.01L1.42 21.24C1.26 21.4 1.05 21.48 0.83 21.48C0.61 21.48 0.4 21.39 0.24 21.24C0.08 21.08 0 20.87 0 20.65C0 20.43 0.09 20.22 0.24 20.06L9.48 10.82C9.48 10.82 9.53 10.7 9.48 10.65L0.25 1.41C-0.07 1.09 -0.07 0.56 0.25 0.24C0.41 0.08 0.61 0 0.84 0C1.07 0 1.27 0.09 1.43 0.24L10.67 9.49C10.67 9.49 10.72 9.53 10.75 9.53C10.78 9.53 10.81 9.52 10.83 9.49L20.08 0.24C20.24 0.08 20.45 0 20.67 0C20.89 0 21.1 0.09 21.26 0.24C21.58 0.56 21.58 1.09 21.26 1.41L12.02 10.65C12.02 10.65 11.97 10.77 12.02 10.82L21.26 20.06C21.58 20.38 21.58 20.91 21.26 21.23C21.1 21.39 20.89 21.47 20.67 21.47V21.49Z" />
  </Icon>
);
